var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 75,
    width: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 0 68.08 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4521 20.3512C65.7733 16.385 63.3687 12.8221 60.3116 9.75771C57.2546 6.70064 53.6843 4.29603 49.7182 2.61721C45.6128 0.879733 41.2434 0 36.7495 0C30.7966 0 24.9537 1.59085 19.8512 4.59661C14.9541 7.48506 10.856 11.5905 7.98218 16.495L8.47336 16.7809C14.3383 6.77395 25.1516 0.571827 36.7495 0.571827C54.8133 0.571827 69.5049 15.2634 69.5049 33.3272C69.5049 51.3251 54.9159 65.98 36.9401 66.0826V66.6545C41.3754 66.6325 45.6714 65.7527 49.7255 64.0373C53.6917 62.3584 57.2546 59.9538 60.319 56.8967C63.376 53.8397 65.7807 50.2694 67.4595 46.3033C69.197 42.1979 70.0767 37.8285 70.0767 33.3346C70.0767 28.8406 69.1896 24.4639 67.4521 20.3512Z",
    fill: "#FF9065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4163 33.3274C5.4163 28.5695 6.49397 23.8776 8.56134 19.6329C8.94989 18.8338 8.66398 17.8735 7.89421 17.4336L7.85756 17.4116C7.00715 16.9204 5.92214 17.2503 5.48961 18.1374C4.5439 20.0801 3.78146 22.1035 3.21696 24.1782C2.41054 27.1473 2 30.2264 2 33.3274C2 38.0193 2.91639 42.572 4.7345 46.8533C6.48664 50.9881 8.98655 54.705 12.1829 57.9013C15.3719 61.0904 19.0888 63.5976 23.2309 65.3497C26.7572 66.8379 30.4667 67.725 34.2789 67.9963C35.2612 68.0622 36.0897 67.2925 36.0897 66.3101V66.2734C36.0897 65.3791 35.4005 64.6533 34.5061 64.5873C18.2677 63.4216 5.4163 49.8444 5.4163 33.3274Z",
    fill: "#FF9065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 61.086C51.7546 61.086 64.086 48.7546 64.086 33.543C64.086 18.3314 51.7546 6 36.543 6C21.3314 6 9 18.3314 9 33.543C9 48.7546 21.3314 61.086 36.543 61.086Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.089 23.7813H26.4982L30.2692 21.0697H30.2689C30.5016 20.8616 30.5403 20.5109 30.3592 20.2564C30.1778 20.0019 29.8343 19.9254 29.5626 20.0789L24.2515 23.8986C24.0934 24.0139 24 24.1981 24 24.3941C24 24.5902 24.0934 24.7744 24.2515 24.8897L29.5626 28.6933C29.8349 28.8581 30.1879 28.7858 30.3738 28.5271C30.5597 28.2681 30.5165 27.9092 30.2742 27.7025L26.5032 24.9909H44.089C45.3336 24.9923 46.5272 25.4887 47.4072 26.3718C48.2874 27.2546 48.7825 28.4518 48.7839 29.7001V33.0405C48.7825 34.2892 48.2874 35.4861 47.4072 36.3689C46.5271 37.252 45.3336 37.7486 44.089 37.75C44.0571 37.7472 44.0251 37.7472 43.9934 37.75V32.2413C43.9926 32.1814 43.9819 32.122 43.9615 32.0655V32.0177C43.9315 31.9693 43.8936 31.926 43.8499 31.8897L43.8073 31.847L43.8075 31.8473C43.7753 31.818 43.7394 31.793 43.7013 31.7724H43.648C43.5888 31.7491 43.5258 31.7364 43.4621 31.7353H29.6208C29.4986 31.7362 29.3806 31.7795 29.2863 31.8577L24.5062 35.7732V35.7735C24.4081 35.8725 24.3461 36.0022 24.331 36.1411V47.4673C24.331 47.6088 24.3868 47.7441 24.4866 47.8442C24.5861 47.944 24.7213 48 24.862 48H38.7988C38.8663 47.9986 38.9331 47.9842 38.9953 47.9575C39.0503 47.9238 39.1049 47.89 39.1599 47.8563L43.8178 43.509C43.9257 43.4086 43.9874 43.2677 43.988 43.1201V38.9542C44.0197 38.9568 44.0516 38.9568 44.0836 38.9542C45.6481 38.9542 47.1489 38.3327 48.2578 37.2252C49.3666 36.118 49.993 34.6154 50 33.0461V29.711C49.9986 28.1389 49.3753 26.6316 48.2673 25.5198C47.159 24.4082 45.6561 23.783 44.0888 23.7815L44.089 23.7813ZM29.8121 32.785H42.0011L40.9387 33.6799H28.7231L29.8121 32.785ZM38.5917 35.619H26.3281L27.4384 34.7401H39.6539L38.5917 35.619ZM38.2519 46.9236H25.3724V36.6845H38.2677L38.2519 46.9236ZM39.3142 46.2309V36.4123L42.9101 33.3862L42.9098 42.8853L39.3142 46.2309Z",
    fill: "#FF9065",
    stroke: "#FF9065",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_151_8727",
    x: 0.275391,
    y: 0.853516,
    width: 96.948,
    height: 96.9482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_151_8727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_151_8727",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_151_8727",
    x1: 54.4732,
    y1: 55.6091,
    x2: 19.0231,
    y2: 11.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.aaded74bc068f811a431f5ce8ec4ce38.svg";
export { ForwardRef as ReactComponent };